var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fc0","d":"M8.248 1.31a.554.554 0 0 0-.994 0L5.468 4.926l-3.992.58a.554.554 0 0 0-.308.946l2.89 2.816-.682 3.977a.555.555 0 0 0 .804.584l3.571-1.877 3.57 1.877a.555.555 0 0 0 .805-.584l-.68-3.977 2.887-2.816a.554.554 0 0 0-.307-.946l-3.992-.58z"}));
}

InlineSvg.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
